<template>
  <div class="white-container full-page-container common-table" :style="activeName !== 'active' ? wonderfulPageStyle : ''">
    <el-tabs v-model="activeName">
      <el-tab-pane label="活动列表" name="active">
        <el-form class="search-bar" :inline="true" size="small">
          <el-form-item label="活动城市">
            <el-select ref="cityBox" v-model="search.city" placeholder="城市">
              <el-option label="全国" value="" />
              <el-option v-for="item in citySelectVO" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间">
            <el-date-picker ref="dateBox" v-model="search.beginTime" type="date" placeholder="选择日期" format-date />
          </el-form-item>
          <el-form-item label="活动状态">
            <el-select ref="statusBox" v-model="search.status" placeholder="选择活动状态">
              <el-option label="全部" value="" />
              <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item class="search-form-item">
            <el-input v-model="search.name" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="activity-preorder operation-bar">
          <el-button size="small" type="primary" @click="releaseActivities">
            <svg-icon icon-class="public" />
            立即发布
          </el-button>
          <el-button size="small" type="primary" @click="openRegistration">
            <svg-icon icon-class="register" />
            开放报名
          </el-button>
        </div>
        <el-table ref="multipleTable" size="small" :data="list" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" fixed />
          <el-table-column prop="id" label="活动ID" width="90" fixed />
          <el-table-column prop="name" label="活动标题" width="auto" min-width="100" />
          <!-- <el-table-column prop="activityCategory" label="活动类别" min-width="100">
            <template v-slot="scope">
              <div v-if="scope.row.activityCategory === 1">常规赛</div>
              <div v-if="scope.row.activityCategory === 2">女子赛</div>
              <div v-if="scope.row.activityCategory === 3">公益球场预约</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="registrationType" label="报名类型" align="center" width="auto" min-width="100">
            <template v-slot="scope">
              <el-tag v-if="scope.row.registrationType === 0" class="registration-system" type="success" size="mini">报名制</el-tag>
              <el-tag v-if="scope.row.registrationType === 1" class="invitation-system" size="mini">特邀制</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="city" label="活动城市" />
          <el-table-column prop="status" label="活动状态" align="center" width="auto" min-width="100">
            <template v-slot="scope">
              <el-tag v-if="scope.row.status === 0" type="success" size="mini">已发布</el-tag>
              <el-tag v-if="scope.row.status === 1" class="el-tag--yellow" size="mini">草稿</el-tag>
              <!-- <el-tag v-if="scope.row.status === 2" class="el-tag--purple" size="mini">审核中</el-tag> -->
              <!-- <el-tag v-if="scope.row.status === 3" class="el-tag--blue" size="mini">待发布</el-tag> -->
              <el-tag v-if="scope.row.status === 4" class="el-tag--red" size="mini">开放报名中</el-tag>
              <el-tag v-if="scope.row.status === 5" class="el-tag--end" size="mini">已结束</el-tag>
              <el-tag v-if="scope.row.status === 6" class="el-tag--gray" size="mini">报名截止</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="beginTime" label="活动开始日期" width="auto" min-width="100">
            <template #default="{ row }">
              {{ $moment(row.beginTime).format("YYYY/MM/DD") || "--" }}
            </template>
          </el-table-column>
          <el-table-column prop="newParticipationNumber" label="报名队伍数" width="auto" min-width="100" />
          <el-table-column fixed="right" width="580px" label="操作">
            <template v-slot="{ row }">
              <el-button v-if="row.status !== 5" size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
              <el-button size="small" type="text" class="link-color" @click="copy(row)">复制</el-button>
              <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
              <el-popover placement="bottom" width="148" style="margin: 0 10px" trigger="click" :popper-options="{ removeOnDestroy: true }">
                <div style="text-align: center">
                  <img :ref="`downLoadImg${row.id}`" src="" alt="" style="width: 100%">
                  <el-button size="small" type="text" class="link-color" @click="downQrCode(row)">下载二维码</el-button>
                </div>
                <el-button slot="reference" size="small" type="text" class="link-color" @click="getErcode(row)">二维码</el-button>
              </el-popover>
              <el-button size="small" type="text" class="link-color" @click="handleShare(row)">分享</el-button>
              <el-button size="small" type="text" class="link-color" @click="exportIdentityCardList(row)">身份证信息表</el-button>
              <el-button v-if="row.status === 5" size="small" type="text" class="link-color" @click="uploadUserActivityData(row)">上传用户活动数据</el-button>
              <el-button v-if="row.status === 5" size="small" type="text" class="link-color" @click="uploadTeamData(row, 'unload')">上传球队数据</el-button>
              <el-button v-if="row.status === 5" slot="reference" size="small" type="text" class="link-color" @click="uploadActivityPhoto(row)">上传活动相册</el-button>
              <el-button size="small" type="text" class="link-color" @click="exportEnrollmentList(row)">报名名单</el-button>
              <el-button v-if="row.status === 1" size="small" type="text" class="link-color" @click="release(row)">发布</el-button>
              <el-button v-else-if="row.status !== 6" size="small" type="text" class="link-color" @click="postOfflineTask(row.id)">下架</el-button>
              <el-button v-if="row.manualSupport === 1" size="small" type="text" class="link-color" @click="uploadTeamData(row, 'import')">导入队伍信息</el-button>
              <el-button v-if="row.isNeedCode" size="small" type="text" class="link-color" @click="activityNum(row)">查看活动码</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="精彩视频" name="wonderful">
        <el-form ref="videoForm" :model="videoForm" :rules="videoRules" label-width="110px" size="small" class="video-container">
          <el-form-item label="上传视频" prop="videoUrl" class="video-wrap">
            <div class="coupon-upload flex ai-center">
              <el-upload ref="uploader" class="xls-uploader" action="" accept="video/*" :show-file-list="false" :on-change="upLoadVideo" :auto-upload="false">
                <el-button v-if="videoForm.videoUrl" size="small" type="primary">重新上传</el-button>
                <el-button v-else size="small" type="primary">上传文件</el-button>
              </el-upload>
              <el-progress v-if="
                uploadProgress != 0 &&
                  uploadProgress != 100 &&
                  uploadProgressStatus
              " class="progress-cont" :text-inside="true" :stroke-width="16" :percentage="uploadProgress"
              />
              <div class="coupon_tip upload_tips" style="margin-left: 15px;">
                支持上传*.MP4、*.MOV格式视频，大小不超过1G，尺寸：16:9
              </div>
              <div v-if="videoForm.videoUrl" class="download-file">
                <video id="player-container" ref="customVideo" :src="videoForm.videoUrl" class="custom-video" preload="auto" controls playsinline webkit-playsinline />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上传视频封面" class="pic-wrap" prop="videoImage">
            <div class="flex">
              <UploadImage :url="videoForm.videoImage || ''" :limit-size="5" save-path="ua_activity/wonderful/video/" title="上传封面图片" size-tips="1005px*566px" @upload="handleCoverPhoto" />
            </div>
          </el-form-item>
          <el-form-item class="wonderful-bottom" :style="videoForm.videoUrl ? 'margin-top: 40px;' : 'margin-top: 221px;'">
            <div class="flex btns jc-center">
              <el-button type="primary" @click="wonderfulSubmit">确定更新</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute; top: -50px; right: 0" @click="add">新增</el-button>
    <el-pagination v-show="activeName === 'active'" background class="fixed-below" :page-size="currentPage.limit" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage.current" :total="currentPage.total" layout="total, prev, pager, next, sizes" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
    />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
    <!-- 弹窗 -->
    <el-dialog v-if="importDialogShow" :visible="importDialogShow" :title="dialogTitle" custom-class="share-wrapper" @close="handleCloseImport">
      <div class="upload-wrapTop">
        <div class="tips">下载导入模板，根据模板完善内容</div>
        <div class="coupon_tip" @click="downloadFileTemplate">
          <i class="el-icon-document" />下载文件模板
        </div>
      </div>
      <div class="upload-wrap">
        <div class="tips">上传完善好的表格，仅支持上传*.xls、*.xlsx格式</div>
        <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false">
          <div>
            <div style="height: 50px">
              <svg-icon icon-class="xls" style="width: 50px; height: 50px" />
            </div>
            <el-button v-if="!classExcel" size="small">选择文件</el-button>
            <template v-else>
              <div class="file">{{ classExcel.name }}</div>
              <el-button size="small">重新选择</el-button>
            </template>
          </div>
        </el-upload>
      </div>
      <div class="flex btns">
        <el-button type="info" @click="handleCloseImport">取消</el-button>
        <el-button type="primary" @click="uploadSubmit">保存</el-button>
      </div>
    </el-dialog>
    <!-- 上传球队及导入队伍信息弹窗 -->
    <el-dialog v-if="teamDialogShow" :visible="teamDialogShow" :title="comDialogTitle" custom-class="share-wrapper" @close="handleCloseTeam">
      <div class="upload-wrapTop">
        <div class="tips">下载导入模板，根据模板完善内容</div>
        <div class="coupon_tip" @click="downloadTeamFileTemplate">
          <i class="el-icon-document" />下载文件模板
        </div>
      </div>
      <div class="upload-wrap">
        <div class="tips">上传完善好的表格，仅支持上传*.xls、*.xlsx格式</div>
        <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handleTeamPushUploader" :auto-upload="false">
          <div>
            <div style="height: 50px">
              <svg-icon icon-class="xls" style="width: 50px; height: 50px" />
            </div>
            <el-button v-if="!teamExcel" size="small">选择文件</el-button>
            <template v-else>
              <div class="file">{{ teamExcel.name }}</div>
              <el-button size="small">重新选择</el-button>
            </template>
          </div>
        </el-upload>
      </div>
      <div class="flex btns">
        <el-button type="info" @click="handleCloseTeam">取消</el-button>
        <el-button type="primary" @click="teamUploadSubmit">保存</el-button>
      </div>
    </el-dialog>
    <!-- 分享弹窗 -->
    <el-dialog v-if="showShare" :visible.sync="showShare" title="选择需要分享的链接类型" custom-class="share-wrapper-box" @close="handleResetShare">
      <el-form ref="shareBox" class="share-form" :model="shareForm" :rules="shareRules">
        <el-form-item label="是否加参" prop="isHaveParameter">
          <el-radio v-model="shareForm.isHaveParameter" :label="1" @change="handleHideTabs">不需要</el-radio>
          <el-radio v-model="shareForm.isHaveParameter" :label="0" @change="handleHideTabs">需要</el-radio>
        </el-form-item>
        <el-form-item label="分享方式" prop="shareWay">
          <el-select v-model="shareForm.shareWay" placeholder="请选择分享方式" style="width: 150px" @change="handleChangeShareWay">
            <el-option v-for="item in shareList" :key="item.id" :label="item.value" :value="item.id" />
          </el-select>
        </el-form-item>
        <template v-if="!shareForm.isHaveParameter">
          <div class="info-wrapper">
            <div class="split" />
            <div class="info-title">基础信息</div>
            <el-form-item label="描述文字" prop="description">
              <el-input v-model="shareForm.description" placeholder="请输入描述文字" style="width: 407px" />
            </el-form-item>
            <div style="display: flex">
              <el-form-item label="活动名称" style="margin-right: 40px">
                <el-input v-model="shareForm.activityName" disabled placeholder="请输入活动名称" style="width: 150px" />
              </el-form-item>
              <el-form-item label="活动类型" prop="activityType">
                <el-select v-model="shareForm.activityType" placeholder="请选择分享方式" style="width: 150px" @change="handleChangeActivityType">
                  <el-option v-for="item in shareSelect.activityType" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </div>
            <div class="share-form-detail">
              <el-form-item label="活动时间:">
                <span :title="shareForm.activeTime">{{
                  shareForm.activeTime || ""
                }}</span>
              </el-form-item>
              <el-form-item label="活动城市:">
                <span :title="shareForm.city">{{ shareForm.city || "" }}</span>
              </el-form-item>
            </div>
          </div>
          <div class="info-wrapper">
            <div class="split" />
            <div class="info-title">参数选择</div>
            <div style="display: flex">
              <el-form-item label="Channel" class="chanel" prop="utmChannel">
                <el-select v-model="shareForm.utmChannel" placeholder="请选择" style="width: 150px" @change="handleRelationSource">
                  <el-option v-for="item in shareSelect.utmChannel" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="Source" class="source" prop="utmSource">
                <el-select v-model="shareForm.utmSource" placeholder="请选择" style="width: 150px; margin-right: 10px" @change="handleRelationChannel">
                  <el-option v-for="item in shareSelect.utmSource" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <el-input v-if="handleFindOther()" v-model="shareForm.utmContent" placeholder="请输入" style="width: 120px" />
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item label="UTM campaign" class="utmCampaign" prop="utmCampaign">
                <el-input v-model="shareForm.utmCampaign" placeholder="请输入活动名称" style="width: 150px" />
              </el-form-item>
              <el-form-item label="UTM media">
                <el-select v-model="shareForm.utmMedium" placeholder="请选择" style="width: 150px" @change="handleChangeShareWay">
                  <el-option v-for="item in shareSelect.utmMedium" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </template>
        <el-form-item class="share-form-btn">
          <el-button type="primary" @click="handleShowTabs">生成链接/二维码</el-button>
        </el-form-item>
      </el-form>
      <template v-if="showTabs && !Object.values(shareData).some(item => !item)">
        <el-tabs v-model="activeTab" class="tabs-wrapper" style="padding-left: 30px; padding-right: 29px">
          <el-tab-pane :label="`${shareList[shareForm.shareWay].value}二维码`" name="code">
            <div class="code-wrapper">
              <div class="code-img">
                <img ref="shareDataImg" :src="
                  shareForm.shareWay === 0
                    ? shareData.miniProgramQrCode
                    : shareData.h5QrCode
                " alt=""
                >
              </div>
              <el-button type="primary" @click="handleDownQrCode">下载二维码</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="`${shareList[shareForm.shareWay].value}链接`" name="link">
            <div class="link-wrapper">
              <div class="link-content">
                <p ref="copyLink" class="content">
                  {{
                    shareForm.shareWay === 0
                      ? shareData.miniProgramLinks
                      : shareData.h5Links
                  }}
                </p>
              </div>
              <el-button type="primary" @click="copyLink">复制链接</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </el-dialog>
    <el-dialog v-if="activityDialogShow" :visible="activityDialogShow" title="活动码" custom-class="share-wrapper" @close="handleCloseActivity">
      <div class="flex activity-num">
        <span class="">{{ activityCode }}</span>
      </div>
      <div class="flex btns">
        <el-button type="primary" @click="copyNum">复制</el-button>
        <!-- <el-button type="primary" @click="teamUploadSubmit">保存</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { formatDate, formatDate1 } from "@/filters";
import { getFileType, imatateDownloadByA } from "@/common/js/util";
import Dialog from "@/components/Dialog";
import UploadImage from "@/components/UploadImage";
import FunctionUtils from "@/utils/functionUtils";

export default {
  components: { Dialog, UploadImage },
  data() {
    const statusList = [
      { id: 0, value: "已发布" },
      { id: 1, value: "草稿" },
      // { id: 2, value: '审核中' },
      // { id: 3, value: '待发布' },
      { id: 4, value: "开放报名中" },
      { id: 6, value: "报名截止" },
      { id: 5, value: "已结束" },
    ];
    return {
      statusList,
      activeName: "active", // active--列表,wonderful--精彩视频
      wonderfulPageStyle:
        "min-height: calc(100vh - 185px) !important; padding-bottom: unset !important;",
      search: {
        city: "",
        name: "",
        beginTime: "",
        status: "",
      },
      searchSubmitted: {},
      enter: -1,
      list: [],
      activityIds: [],
      dialogTitle: "", // 弹窗名称
      classExcel: null,
      teamExcel: null, // 球队数据
      formDialogShow: false,
      importDialogShow: false, // 上传榜单弹窗开关
      teamDialogShow: false, // 上传球队数据弹窗开关
      information: {},
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
      showShare: false, // 分享弹窗
      showTabs: false,
      activeTab: "code",
      shareForm: {
        isHaveParameter: 1,
        shareWay: 0,
        activityId: "",
        activityName: "",
        activityType: null,
        description: "",
        activeTime: "",
        city: "",
        utmChannel: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: "",
        utmContent: "",
      },
      shareData: {
        h5Links: "",
        h5QrCode: "",
        miniProgramLinks: "",
        miniProgramQrCode: "",
      },
      shareSelect: {
        activityType: [],
        utmChannel: [],
        utmContent: [],
        utmMedium: [],
        utmSource: [],
      },
      shareList: [
        { id: 0, value: "小程序" },
        // { id: 1, value: 'H5' },
      ],
      shareRules: {
        isHaveParameter: [
          { required: true, message: "请选择是否需要加参", trigger: "change" },
        ],
        shareWay: [
          { required: true, message: "请选择分享方式", trigger: "change" },
        ],
      },
      videoForm: {
        videoUrl: "",
        videoImage: "",
      },
      videoRules: {
        videoUrl: [{ required: true, message: "请上传视频", trigger: "change" }],
        videoImage: [
          { required: true, message: "请上传视频封面", trigger: "change" },
        ],
      },
      uploadProgress: 0, // 视频上传的进度
      uploadProgressStatus: false,
      state: '', // 传球队及导入队伍信息状态
      comDialogTitle: '', // 上传球队及导入队伍信息弹窗标题
      activityDialogShow: false, // 活动码弹框
      activityCode: '', // 活动码
    };
  },
  beforeRouteLeave(to, form, next) {
    const list = [
      "/activity/letsBasketball/edit",
      "/activity/letsBasketball/edit",
      "/activity/letsBasketball/photoUpload",
    ];
    if (!list.includes(to.path)) {
      this.enter = 0;
      this.searchSubmitted = {};
      this.search = {
        city: "",
        id: "",
        name: "",
        beginTime: "",
        status: "",
      };
    }
    next();
  },
  computed: {
    ...mapState("activity", ["citySelectVO"]),
  },
  activated() {
    this.enter += 1;
    if (this.enter) {
      this.classExcel = null;
      this.searchSubmit();
    }
  },
  mounted() {
    this.getList();
    this.fetchWonderful();
    this.fetchBuriedChannel();
  },

  methods: {
    getList() {
      this.$Api.letsBasketball
        .postLetsBasketballList({
          ...this.currentPage,
          ...this.searchSubmitted,
        })
        .then(res => {
          this.currentPage.total = res.total;
          this.list = res.data;
        });
    },
    searchSubmit() {
      this.searchSubmitted = {};
      Object.keys(this.search).forEach(key => {
        if (key === "beginTime") {
          this.searchSubmitted["beginTime"] = formatDate(this.search[key]);
        } else {
          this.searchSubmitted[key] = this.search[key];
        }
      });
      this.currentPage.current = 0;
      this.getList();
    },
    releaseActivities() {
      this.$Api.letsBasketball
        .releaseLetsBasketball(this.activityIds)
        .then(res => {
          this.$message.success("发布成功");
          this.getList();
        });
    },
    openRegistration() {
      this.$Api.letsBasketball.openRegistration(this.activityIds).then(res => {
        this.$message.success("开放报名成功");
        this.getList();
      });
    },
    // 重置搜索
    reset() {
      this.searchSubmitted = {};
      this.search = {
        city: "",
        id: "",
        name: "",
        beginTime: "",
        status: "",
      };
      this.currentPage.current = 1;
      this.getList();
    },
    submitSucces(operation) {
      if (operation === "delete") {
        this.$Api.letsBasketball.delLetsBasketball(this.currentID).then(() => {
          this.$message.success("删除成功");
          this.currentPage.current = (this.currentPage.current -=
            this.list.length === 1 && 1)
            ? 1
            : this.currentPage.current;
          this.getList();
        });
      } else if (operation === "copy") {
        this.$router.push({
          path: "/activity/letsBasketball/add",
          query: { copyId: this.currentID },
        });
      } else if (operation === "edit") {
        this.$router.push({
          path: "/activity/letsBasketball/edit",
          query: { id: this.currentID },
        });
      } else if (operation === "release") {
        this.$Api.letsBasketball
          .releaseLetsBasketball([this.currentID])
          .then(res => {
            this.$message.success("发布成功");
            this.getList();
          });
      } else if (operation === "offline") {
        this.$Api.letsBasketball
          .offlineLetsBasketball([this.currentID])
          .then(res => {
            this.$message.success("下架成功");
            this.getList();
          });
      }
    },
    // 删除
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: "delete",
        icon: "warn",
        subTitle: "删除后小程序用户将无法查看该活动，请确认是否删除",
      };
    },
    release(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: "release",
        icon: "warn",
        subTitle: `是否确认发布活动ID为“${this.currentID}”的数据项？`,
      };
    },
    postOfflineTask(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: "offline",
        icon: "warn",
        subTitle: `是否确认下架活动ID为“${this.currentID}”的数据项？`,
      };
    },
    exportEnrollmentList(row) {
      this.$Api.letsBasketball.exportEnrollmentList(row.id).then(res => {
        if (!res) {
          this.$message.error("该Lets三人篮球活动暂无报名人员");
        } else {
          this.$message.success("导出成功");
        }
      });
    },
    handlePushUploader(file) {
      if (getFileType(file.raw.name) !== "excel") {
        this.$message.error("导入失败，请选择Excel文件");
        return;
      }
      this.classExcel = file.raw;
    },
    uploadSubmit() {
      if (!this.classExcel) {
        this.$message.warning("请先选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.classExcel);
      formData.append("id", this.currentID);
      this.$Api.letsBasketball.uploadLetsBasketball(formData).then(res => {
        this.$message.success("导入成功");
        this.getList();
        this.handleCloseImport();
      });
    },
    uploadUserActivityData(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = "上传用户活动数据";
    },
    // 上传球队数据及导入队伍信息
    uploadTeamData(row, state) {
      this.state = state;
      switch (state) {
        case 'unload':
          this.comDialogTitle = '上传球队数据';
          break;
        case 'import':
          this.comDialogTitle = '导入队伍信息';
          break;
      }
      this.currentID = row.id;
      this.teamDialogShow = true;
    },
    // 下载球队数据模版
    downloadTeamFileTemplate() {
      let fileUrl;
      switch (this.state) {
        case 'unload':
          fileUrl =
          "https://uaprd-1257321318.cos.ap-beijing.myqcloud.com/static/excel/Let%E2%80%98s%203%E9%98%9F%E4%BC%8D%E4%BF%A1%E6%81%AF%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx";
          break;
        case 'import':
          fileUrl =
          "https://uaprd-1257321318.cos.ap-beijing.myqcloud.com/static/excel/letUsManuallyImportTheRegistrationListTemplate.xlsx";
          break;
      }

      window.open(fileUrl);
    },
    // 活动码弹框
    activityNum(row) {
      this.activityCode = row.code;
      this.activityDialogShow = true;
    },
    handleCloseActivity() {
      this.activityDialogShow = false;
    },
    copyNum() {
      navigator.clipboard.writeText(this.activityCode).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    handleTeamPushUploader(file) {
      if (getFileType(file.raw.name) !== "excel") {
        this.$message.error("导入失败，请选择Excel文件");
        return;
      }
      this.teamExcel = file.raw;
    },
    // 确认上传球队数据
    teamUploadSubmit() {
      if (!this.teamExcel) {
        this.$message.warning("请先选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.teamExcel);
      formData.append("id", this.currentID);
      switch (this.state) {
        case 'unload':
          this.$Api.letsBasketball.uploadTeamLetsBasketball(formData).then(res => {
            this.$message.success("导入成功");
            this.getList();
            this.handleCloseTeam();
          });
          break;
        case 'import':
          this.$Api.letsBasketball.importUserManuallyRegistrationList(formData).then(res => {
            console.log(res);
            if (res.length === 0) {
              this.$message.success("导入成功");
              this.getList();
              this.handleCloseTeam();
            } else {
              this.$message.error(res.join(''));
            }
          });
          break;
      }
    },
    // 分享
    handleShare(row) {
      console.log("row =====>", row);
      const activeTime = `${formatDate1(row.beginTime)} - ${formatDate1(
        row.endTime
      )}`;
      this.currentID = row.id;
      this.shareForm = {
        ...this.shareForm,
        activityId: row.id,
        activityName: row.name,
        activeTime: activeTime,
        city: row.city,
      };
      this.showShare = true;
    },
    handleRelationChannel(val) {
      this.shareForm.utmContent = "";
      if (!this.shareForm.utmChannel && val === -99) {
        this.shareForm.utmSource = null;
        this.$message.warning("请先选择Channel，再选择其他");
        return;
      }
      if (val === -99) return;
      this.shareForm.utmChannel = null;
      this.$Api.activity
        .buriedChannelSelectTwoStageLinkage({
          utmSourceId: val,
        })
        .then(res => {
          if (res && res.length) {
            this.shareForm.utmChannel = this.shareSelect.utmChannel.find(
              item => item.name === res[0].name
            ).id;
          }
        });
    },
    handleFindOther() {
      if (!this.shareForm.utmSource) return false;
      const { name } = this.shareSelect.utmSource.find(
        item => item.id === this.shareForm.utmSource
      );
      return name === "其他";
    },
    //  Channel关联Source
    handleRelationSource(val) {
      this.shareForm.utmContent = "";
      this.shareForm.utmSource = null;
      this.$Api.activity
        .buriedChannelSelectTwoStageLinkage({
          utmChannelId: val,
        })
        .then(res => {
          if (res && res.length) {
            this.shareSelect.utmSource = [
              ...res,
              {
                id: -99,
                parentId: null,
                type: 1,
                name: "其他",
                remark: "",
              },
            ];
            this.$refs.shareBox.validateField("utmSource");
          }
        });
    },
    // 改变活动类型
    handleChangeActivityType(val) {
      this.$Api.activity
        .buriedChannelCampaign({
          activityId: this.shareForm.activityId,
          activityType: val,
        })
        .then(res => {
          if (res) {
            this.shareForm.utmCampaign = res;
            this.$refs.shareBox.validateField("utmCampaign");
          }
        });
    },
    // 复制活动分享链接
    copyLink() {
      if (!this.$refs.copyLink && !this.$refs.copyLink.innerText) return;
      navigator.clipboard.writeText(this.$refs.copyLink.innerText).then(() => {
        this.$message.success("复制成功");
      });
    },
    // 下载活动分享带参/不带参二维码
    handleDownQrCode() {
      if (!this.$refs.shareDataImg || !this.$refs.shareDataImg.src) return;
      imatateDownloadByA(
        this.$refs.shareDataImg.src,
        `${this.shareForm.name || "活动分享"}.png`
      );
    },
    // 改变分享方式
    handleChangeShareWay() {
      this.activeTab = "code";
      this.handleHideTabs();
    },
    handleHideTabs(val) {
      this.handleChangeShareRules();
      this.showTabs = false;
    },
    fetchBuriedChannel() {
      this.$Api.activity.buriedChannelSelect().then(res => {
        if (res) {
          if (res.utmChannel && res.utmChannel.length) {
            res.utmChannel = FunctionUtils.objectReset(res.utmChannel, "name");
          }
          if (res.utmSource && res.utmSource.length) {
            res.utmSource.push({
              id: -99,
              parentId: null,
              type: 1,
              name: "其他",
              remark: "",
            });
          }
          this.shareSelect = res;
        }
      });
    },
    // 生成二维码，链接
    handleShowTabs() {
      const params = this.handleDealParams();
      console.log(params);
      this.$refs.shareBox.validate(valid => {
        if (valid) {
          // 不需要带参
          if (this.shareForm.isHaveParameter === 1) {
            this.$Api.activity
              .buriedChannel({
                activityId: this.currentID,
                isHaveParameter: this.shareForm.isHaveParameter,
                objectType: 3, // 3同lets3
              })
              .then(res => {
                res && (this.shareData = res);
                this.showTabs = true;
              });
          } else {
            const params = this.handleDealParams();
            this.$Api.activity.buriedChannel(params).then(res => {
              res && (this.shareData = res);
              this.showTabs = true;
            });
          }
        }
      });
    },
    // 动态改变校验规则
    handleChangeShareRules() {
      if (this.shareForm.isHaveParameter === 1) {
        this.shareRules = {
          isHaveParameter: [
            { required: true, message: "请选择是否需要加参", trigger: "change" },
          ],
          shareWay: [
            { required: true, message: "请选择分享方式", trigger: "change" },
          ],
        };
      } else {
        this.shareRules = {
          ...this.shareRules,
          description: [
            { required: true, message: "请输入描述文字", trigger: "blur" },
          ],
          activityType: [
            { required: true, message: "请选择活动类型", trigger: "change" },
          ],
          utmChannel: [
            { required: true, message: "请选择Channel", trigger: "change" },
          ],
          utmSource: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请选择Source"));
                }
                const obj = this.shareSelect.utmSource.find(
                  item => item.id === value
                );
                if (obj && obj.name === "其他" && !this.shareForm.utmContent) {
                  callback(new Error("请输入Source"));
                } else {
                  callback();
                }
              },
              trigger: "change",
            },
          ],
          utmCampaign: [
            { required: true, message: "请输入活动名称", trigger: "blur" },
          ],
        };
      }
    },
    // 处理活动带参
    handleDealParams() {
      const defaultParams = {
        objectType: 3,
        activityId: this.shareForm.activityId,
        activityName: this.shareForm.activityName,
        isHaveParameter: this.shareForm.isHaveParameter,
      };
      if (this.shareForm.activityType) {
        defaultParams["activityType"] = this.shareForm.activityType;
      }
      if (this.shareForm.description) {
        defaultParams["description"] = this.shareForm.description;
      }
      if (this.shareForm.utmCampaign) {
        defaultParams["utmCampaign"] = this.shareForm.utmCampaign;
      }
      if (
        this.shareForm.utmChannel &&
        this.shareSelect.utmChannel &&
        this.shareSelect.utmChannel.length
      ) {
        const { name } = this.shareSelect.utmChannel.find(
          item => item.id === this.shareForm.utmChannel
        );
        name && (defaultParams["utmChannel"] = name);
      }
      if (
        this.shareForm.utmSource &&
        this.shareSelect.utmSource &&
        this.shareSelect.utmSource.length
      ) {
        const { name } = this.shareSelect.utmSource.find(
          item => item.id === this.shareForm.utmSource
        );
        if (name === "(空)") {
          defaultParams["utmSource"] = null;
        } else if (name === "其他") {
          defaultParams["utmSource"] = this.shareForm.utmContent;
        } else {
          defaultParams["utmSource"] = name;
        }
      }
      if (
        this.shareForm.utmMedium &&
        this.shareSelect.utmMedium &&
        this.shareSelect.utmMedium.length
      ) {
        const { name } = this.shareSelect.utmMedium.find(
          item => item.id === this.shareForm.utmMedium
        );
        defaultParams["utmMedium"] = name;
      }
      return defaultParams;
    },
    // 重置分享表单
    handleResetShare() {
      this.shareData = {
        h5Links: "",
        h5QrCode: "",
        miniProgramLinks: "",
        miniProgramQrCode: "",
      };
      this.shareForm = {
        isHaveParameter: 1,
        shareWay: 0,
        activityId: "",
        activityName: "",
        activityType: null,
        description: "",
        activeTime: "",
        city: "",
        utmChannel: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: "",
        utmContent: "",
      };
      this.activeTab = "code";
      this.handleChangeShareRules();
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: "copy",
        icon: "success",
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    // 下载二维码
    downQrCode(row) {
      // 创建a链接下载
      const link = document.createElement("a");
      link.href = this.$refs[`downLoadImg${row.id}`].src;
      link.download = `${row.name}.png`;
      link.target = "_blank";
      link.click();
    },
    getErcode(row) {
      this.$Api.activity.getActivityCode(row.id).then(res => {
        this.$refs[`downLoadImg${row.id}`].src = res;
      });
    },
    exportIdentityCardList(row) {
      this.$Api.letsBasketball
        .exampleExportTheIDCardInformationTable(row.id)
        .then(res => {
          if (!res) {
            this.$message.error("该Lets3活动暂无报名人员");
          } else {
            this.$message.success("导出成功");
          }
        });
    },
    handleSelectionChange(val) {
      this.activityIds = val.map(item => item.id);
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },
    // 关闭弹窗
    handleCloseImport() {
      this.importDialogShow = false;
      this.classExcel = null;
    },
    // 关闭上传球队数据弹窗
    handleCloseTeam() {
      this.teamDialogShow = false;
      this.teamExcel = null;
    },
    // 下载用户活动数据模板
    downloadFileTemplate() {
      const fileUrl =
        "https://uaprd-1257321318.cos.ap-beijing.myqcloud.com/static/excel/Let%27s%203%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx";
      window.open(fileUrl);
    },
    uploadActivityPhoto(row) {
      this.$router.push({
        path: "/activity/letsBasketball/photo-album-upload",
        query: row,
      });
    },
    add() {
      this.$router.push({ path: "/activity/letsBasketball/add" });
    },
    edit(row) {
      if ([0, 2, 4].indexOf(row.status) !== -1) {
        this.formDialogShow = true;
        this.currentID = row.id;
        const subTitle =
          row.status === 0
            ? "活动已发布，编辑将会更新活动信息，是否继续？"
            : "活动已开放报名，编辑将会更新活动信息，是否继续？";
        this.information = {
          operation: "edit",
          icon: "warn",
          subTitle: subTitle,
        };
      } else {
        this.$router.push({
          path: "/activity/letsBasketball/edit",
          query: { id: row.id },
        });
      }
    },
    // 上传精彩视频封面
    handleCoverPhoto(url) {
      this.videoForm.videoImage = url;
      this.$refs.videoForm.validateField("videoImage");
      this.$forceUpdate();
    },
    // 视频检查
    asyncVideoChecked(file) {
      const _this = this;

      const width = 16;
      const height = 9;
      const videoElement = document.createElement('video');
      videoElement.addEventListener('loadedmetadata', function (_event) {
        const vwidth = videoElement.videoWidth;
        const vheight = videoElement.videoHeight;
        const valid = (vwidth / vheight) === (width / height);
        if (valid) {
          _this.uploadProgressStatus = true;
          _this.$Api.uploadFile.putCloudDemandUpload({
            mediaFile: file.raw,
            onUploadProgress: progressEvent => {
              const process =
                parseInt((progressEvent.loaded / progressEvent.total) * 100) || 0;
              console.log('process', process);
              _this.uploadProgress = process;
            },
          }).then(res => {
            _this.uploadProgressStatus = false;
            _this.videoForm.videoUrl = res.mediaUrl;
            _this.$refs.videoForm.validateField("videoUrl");
          }).catch(_ => {
            _this.uploadProgress = 0;
            _this.uploadProgressStatus = false;
            _this.$message.error("上传失败！");
          });
        } else {
          _this.$message.error(`视频宽高比必须是16:9`);
          _this.$refs.uploader.clearFiles();
        }
      });
      const _URL = window.URL || window.webkitURL;
      try {
        videoElement.srcObject = file.raw;
      } catch (error) {
        videoElement.src = _URL.createObjectURL(file.raw);
      }
    },
    // 上传视频
    upLoadVideo(file) {
      const type = getFileType(file.name);
      if (type !== "video") {
        this.$message.error('视频格式不正确');
        this.$refs.uploader.clearFiles();
        return;
      }
      if (parseFloat(file.raw.size / 1024 / 1024) > 1024) {
        this.$message.error(`视频大小不能超过1G`);
        this.$refs.uploader.clearFiles();
        return;
      }
      this.asyncVideoChecked(file);
    },
    // 精彩视频确认更新
    wonderfulSubmit() {
      console.log('确认更新');
      this.$refs.videoForm.validate((valid) => {
        if (valid) {
          // const formData = new FormData();
          // const param = { ...this.videoForm };
          // formData.append('letsBasketballExcitingVideosDTO', new Blob([JSON.stringify(param)], { type: 'application/json' }));
          this.$Api.letsBasketball.editLetsBasketballVideo(this.videoForm).then(res => {
            this.$message.success(`更新成功`);
          }).catch(err => {
            if (err && !err.success) {
              console.error(err.errorMessage || `更新失败`);
              this.$message.error(`更新失败`);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 获取精彩视频详情
    fetchWonderful() {
      this.$Api.letsBasketball.getLetsBasketballVideoDetail().then(res => {
        if (res) {
          this.videoForm = res;
        } else {
          this.videoForm = {
            videoUrl: "",
            videoImage: "",
          };
        }
        console.log(res, 666);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.progress-cont {
  margin-left: 15px;
  width: 300px;
  margin-top: 8px;
}
.registration-system {
  background: #494949;
  color: #ffffff;
  width: 58px !important;
}
.invitation-system {
  background: #caa670;
  color: #ffffff;
  width: 58px !important;
}
.el-tag {
  font-size: 14px;
  font-weight: 400;
}
.el-tag.el-tag--purple {
  background-color: rgba(114, 46, 209, 0.1);
  border-color: rgba(114, 46, 209, 0.7);
  color: #722ed1;
}
.el-tag.el-tag--yellow {
  background-color: rgba(234, 153, 33, 0.1);
  border-color: rgba(234, 153, 33, 0.7);
  color: #ea9921;
}
.el-tag.el-tag--blue {
  background-color: rgba(24, 144, 255, 0.1);
  border-color: rgba(24, 144, 255, 0.7);
  color: #1890ff;
}
.el-tag.el-tag--red {
  background-color: rgba(220, 0, 25, 0.1);
  border-color: rgba(220, 0, 25, 0.7);
  color: #dc0019;
}
.el-tag.el-tag--end {
  background-color: rgba(73, 73, 73, 0.1);
  border-color: rgba(155, 155, 155, 0.7);
  color: #9b9b9b;
}
.el-tag.el-tag--gray {
  background-color: rgba(73, 73, 73, 0.2);
  border-color: rgba(155, 155, 155, 0.7);
  color: #9b9b9b;
}
.button-img {
  width: 12px;
  height: 12px;
  position: absolute;
  left: 14px;
}
.jc-center {
  justify-content: center;
}
.ai-center {
  align-items: center;
}
.upload-button {
  display: flex;
  padding-left: 30px;
  align-items: center;
  position: relative;
}
.upload_tips {
  color: #bbbbbb;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper-box {
    width: 678px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      max-height: calc(100vh - 6.85vh - 66px - 30px - 30px);
      overflow-y: auto;
      padding: 2.5vh 0 2.78vh 0;
      .share-form {
        padding-left: 30px;
        box-sizing: border-box;
        .el-form-item {
          display: flex;
        }
        .utmCampaign {
          margin-right: 10px;
          .el-input {
            margin-left: -8px;
          }
          .el-form-item__error {
            left: -8px;
          }
        }
        .share-form-btn {
          margin-bottom: unset;
          justify-content: center;
          margin-left: -30px;
          .el-form-item__content {
            margin-left: unset !important;
            text-align: center;
            .el-button {
              height: 4.63vh;
              line-height: 4.63vh;
              padding: 0 1.85vh;
              span {
                font-family: "Noto Sans SC";
                font-style: normal;
                font-weight: 400;
                font-size: 1.48vh;
              }
            }
          }
        }
        .info-wrapper {
          .share-form-detail {
            display: flex;
            // justify-content: space-between;
            flex-wrap: nowrap;
            margin-right: 30px;
            overflow-x: hidden;
            text-overflow: ellipsis;
            .el-form-item {
              white-space: nowrap;
              span {
                margin-right: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              &:nth-of-type(n + 2) {
                margin-left: 40px;
              }
            }
          }
          .chanel {
            margin-right: 10px;
            .el-form-item__label {
              width: 108.96px;
              white-space: nowrap;
            }
          }
          .source {
            .el-form-item__label {
              width: 84.63px;
              white-space: nowrap;
            }
          }
          .split {
            width: 600px;
            height: 1px;
            background: #e3e3e5;
          }
          .info-title {
            font-family: "Noto Sans SC";
            font-style: normal;
            font-weight: 500;
            font-size: 1.44vh;
            color: #000000;
            margin: 20px 0;
          }
        }
      }
      .tabs-wrapper {
        .code-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .code-img {
            width: 13.89vh;
            height: 13.89vh;
            margin-bottom: 2.78vh;
            img {
              width: 100%;
            }
          }
          .el-button {
            height: 3.15vh;
            line-height: 3.15vh;
            padding: 0 1.85vh;
            span {
              font-family: "Noto Sans SC";
              font-style: normal;
              font-weight: 400;
              font-size: 1.48vh;
            }
          }
        }
        .link-wrapper {
          text-align: center;
          .link-content {
            text-align: left;
            height: 13.89vh;
            background: #eeeeee;
            border: 1px solid #e3e3e5;
            border-radius: 0.37vh;
            margin-bottom: 2.78vh;
            padding: 1.85vh 1.39vh;
            font-family: "Noto Sans SC";
            font-size: 1.48vh;
            line-height: 2.22vh;
            color: #000000;
            .content {
              height: 11.11vh;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .el-button {
            height: 3.15vh;
            line-height: 3.15vh;
            padding: 0 1.85vh;
            span {
              font-family: "Noto Sans SC";
              font-style: normal;
              font-weight: 400;
              font-size: 1.48vh;
            }
          }
        }
      }
    }
  }
  /deep/ .share-wrapper {
    width: 538px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px;
      .upload-wrapTop {
        width: 100%;
        height: 114px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        margin-bottom: 20px;
        padding: 20px 30px;
        > .tips {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        > .coupon_tip {
          cursor: pointer;
          user-select: none;
          width: 130px;
          height: 34px;
          background: #ffffff;
          border: 1px solid #bbbbbb;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          line-height: 20px;
          color: #000000;
          > i {
            margin-right: 7px;
          }
        }
        > .coupon_tip:hover {
          background: #f7f7f7;
          color: #afafaf;
        }
      }
      .upload-wrap {
        width: 100%;
        height: 250px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        padding: 20px 30px;
        box-sizing: border-box;
        .el-input__inner {
          height: 34px !important;
        }
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .tips {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .activity-num {
      justify-content: center;
      font-size: 48px;
      color: #000000;
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
.video-container {
  .coupon-upload {
    flex-wrap: wrap;
    .download-file {
      flex-basis: 100%;
      margin-top: 20px;
      .custom-video {
        width: 266px;
        height: 150px;
      }
    }
  }

  :deep(.video-wrap) {
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-top: 20px;
      margin-left: unset !important;
    }
  }
  :deep(.pic-wrap) {
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-top: 20px;
      margin-left: unset !important;
    }
  }
  .wonderful-bottom {
    width: 100%;
    margin-left: -50px;
    text-align: center;
  }
}
</style>
